import React, { useCallback, useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router'
import { ComcastErrorType, generateErrorData } from '../../../../shared/helpers.js'
import { useKeyDown } from '../../../../shared/providers/KeyDownProvider'
import { KeyTypeEnum } from '../../../../shared/providers/KeyDownProvider/types'
import Spinner from '../../components/Spinner'
import { useAppDispatch } from '../../hooks/useStore'
import { useVideoDetails } from '../../hooks/useVideoDetails'
import googleAnalytics4 from '../../lib/googleAnalytics.js'
import tts from '../../lib/TTS.js'
import Platform from '../../platforms'
import VideoDetailContainer from './VideoDetailContainer'

function VideoDetailScreen() {
  const routerParams = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useAppDispatch()
  const {
    videoDetails,
    error: errorGettingVideoDetails,
    loading: loadingVideoDetails,
  } = useVideoDetails(routerParams.url || '')

  const fromResumeModal = (location.state as { fromResumeModal?: boolean })
    ?.fromResumeModal
  const fromVPPA = (location.state as { fromVPPA?: boolean })?.fromVPPA
  const fromPassportUpsell = (location.state as { fromPassportUpsell?: boolean })
    ?.fromPassportUpsell

  useEffect(() => {
    if (!loadingVideoDetails && videoDetails?.url) {
      googleAnalytics4.sendPageViewEvent(
        `Video Details | ${videoDetails.showTitle} | ${videoDetails.episodeTitle}`
      )
    }
  }, [loadingVideoDetails])

  useEffect(() => {
    Platform.reportAppReady()
    tts.stop()
    // TODO: remove this when whole app is migrated to react spatial navigation
    window.focusedComponent = {}
    window.focusedComponent.handleBySpatialNavigation = true
    return () => {
      tts.stop()
      window.focusedComponent.handleBySpatialNavigation = false
    }
  }, [])

  if (errorGettingVideoDetails) {
    const errorObj = generateErrorData(errorGettingVideoDetails)

    dispatch({
      type: 'TRIGGER_ERROR',
      payload: {
        error: {
          ...errorObj,
          content: {
            errorPath: location.pathname,
          },
          codeBaseLocation: 'VideoDetailScreen - updateContent',
          errorType: ComcastErrorType.network,
        },
      },
    })
    navigate('/error', { replace: true })
  }
  useKeyDown(
    KeyTypeEnum.Back,
    useCallback(() => {
      if (fromVPPA) {
        navigate(-2)
        return
      }

      if (fromResumeModal || fromPassportUpsell) {
        navigate('/home', { replace: true })
        return
      }

      navigate(-1)
    }, [navigate, fromResumeModal, fromVPPA, fromPassportUpsell]),
    { stopPropagation: true }
  )

  const renderSpinner = loadingVideoDetails && !videoDetails?.url

  return (
    <>
      {renderSpinner && <Spinner />}
      {!renderSpinner && <VideoDetailContainer />}
    </>
  )
}

export default VideoDetailScreen
